<template>
    <!-- eslint-disable vue/no-v-html -->
    <div class="int-result-option" :class="{'int-result-option--sub': subCity}">
        <span>
            <city-icon width="24px" height="24px" fill="currentColor" v-if="city" />
            <plane-icon width="24px" height="24px" fill="currentColor" v-else-if="!subCity" />
            <arrow-right-break-icon width="15px" height="15px" class="mt-2" v-else />
        </span>
        <span class="inline-block">
            <span class="int-result-option__subtitle" v-if="!city" v-html="boldText(item.domainCode.substr(0, 3))" />

            <span class="block text-ellipsis">
                <span v-if="city" v-html="boldText(item.city.name)" />

                <span class="small" v-if="item.domainCode.length > 3">All airports</span>
                <span v-html="boldText(item.name)" v-else />&emsp;
            </span>

            <small class="block">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <span v-if="!city" v-html="`${boldText(item.city.name)}, `" />
                <!-- eslint-disable-next-line vue/no-v-html -->
                <span v-html="boldText(item.city.country.name)" />
            </small>
        </span>
    </div>
</template>
<script>
import CityIcon from '~icons/city';
import PlaneIcon from '~icons/airplane';
import ArrowRightBreakIcon from '~icons/international/arrow-right-break';
import common from '~/scripts/mixins/international/common';

export default {
    components: {
        CityIcon,
        PlaneIcon,
        ArrowRightBreakIcon,
    },
    mixins: [
        common,
    ],
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        query: {
            type: String,
            default: '',
        },
    },
    computed: {
        subCity () {
            return !!this.item.subcity;
        },
        city () {
            return this.isCity(this.item);
        },
    },
    methods: {
        // bold searched text in result
        boldText (text) {
            const query = this.$parent.inputValue;
            if (!query) return text;
            // example: query:'ist', text:'Istanbul', output: '<strong>Ist</strong>anbul'
            return text.replace(new RegExp(query, 'gi'), match => {
                return '<mark class="p-0">' + match + '</mark>';
            });
        },
    },
};
</script>
<style lang="scss">
    @import '~vars';

    .int-result-option {
        direction: ltr;
        text-align: left;
        font-weight: 400;
        font-size: 1.05em;
        position: relative;
        color: $new-black !important;
        overflow: auto;

        &::before {
            content: none !important;
            display: none !important;
        }

        svg {
            position: absolute;
            left: 5px;
            opacity: 0.5;
        }

        > span {
            display: block;
            margin: 0 30px 0 40px;
        }

        &__subtitle {
            position: absolute;
            right: 10px;
            top: 12px;
        }

        &--sub {
            margin-left: 30px;
        }

        mark {
            color: inherit;
        }

        small {
            color: $dark-gray !important;
        }
    }

    .multitab-picker__items > li.active > a > .int-result-option {

        & {
            color: $blue-strong !important;
        }

        svg {
            opacity: 1;
        }
    }
</style>
